import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export default {
	getIndexes (cb, errorCb) {
		Vue.http.get('https://api.coindesk.com/v1/bpi/currentprice.json?t=123454').then(response => {
			cb(response.body);
		}, response => {
			errorCb (response)
		});
	}
}
